/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { UserDto } from '../models/user-dto';
import { UsersPageResponseDto } from '../models/users-page-response-dto';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation loadUser
   */
  static readonly LoadUserPath = '/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loadUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadUser$Response(params?: {
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UsersService.LoadUserPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `loadUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loadUser(params?: {
  }): Observable<UserDto> {

    return this.loadUser$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation getCompanyUsers
   */
  static readonly GetCompanyUsersPath = '/list';

  /**
   * Returns company users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyUsers$Response(params: {
    search?: string;
    page?: number;
    size: number;
  }): Observable<StrictHttpResponse<UsersPageResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, UsersService.GetCompanyUsersPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UsersPageResponseDto>;
      })
    );
  }

  /**
   * Returns company users.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompanyUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyUsers(params: {
    search?: string;
    page?: number;
    size: number;
  }): Observable<UsersPageResponseDto> {

    return this.getCompanyUsers$Response(params).pipe(
      map((r: StrictHttpResponse<UsersPageResponseDto>) => r.body as UsersPageResponseDto)
    );
  }

}
